import { jsx } from "react/jsx-runtime";
import { token } from "@/styled-system/tokens";
import { Box } from "@zillow/constellation-10";
const HEADING_COLOR = {
  blue: token.var("colors.blue.600"),
  darkBlue: token.var("colors.text.onImpact.neutral-fixed"),
  gold: token.var("colors.yellow.500"),
  green: token.var("colors.green.500"),
  orange: token.var("colors.orange.500"),
  purple: token.var("colors.purple.500"),
  white: token.var("colors.text.neutral")
};
const TEXT_COLOR = {
  blue: token.var("colors.black"),
  darkBlue: token.var("colors.text.onImpact.neutral-fixed"),
  gold: token.var("colors.black"),
  green: token.var("colors.black"),
  orange: token.var("colors.black"),
  purple: token.var("colors.black"),
  white: token.var("colors.text.neutral")
};
const TEXT_LEGAL_COLOR = {
  blue: token.var("colors.text.neutral"),
  darkBlue: token.var("colors.gray.400"),
  gold: token.var("colors.text.neutral"),
  green: token.var("colors.text.neutral"),
  orange: token.var("colors.text.neutral"),
  purple: token.var("colors.text.neutral"),
  white: token.var("colors.gray.400")
};
const BUTTON_COLOR = {
  blue: token.var("colors.blue.600"),
  darkBlue: token.var("colors.blue.600"),
  gold: token.var("colors.yellow.500"),
  green: token.var("colors.green.500"),
  orange: token.var("colors.orange.500"),
  purple: token.var("colors.purple.500"),
  white: token.var("colors.blue.600")
};
const BUTTON_HOVER_COLOR = {
  blue: token.var("colors.blue.700"),
  darkBlue: token.var("colors.blue.700"),
  gold: token.var("colors.yellow.600"),
  green: token.var("colors.green.600"),
  orange: token.var("colors.orange.600"),
  purple: token.var("colors.purple.600"),
  white: token.var("colors.blue.700")
};
const BACKGROUND_COLOR = {
  blue: token.var("colors.blue.100"),
  darkBlue: token.var("colors.blue.900"),
  gold: token.var("colors.yellow.100"),
  green: token.var("colors.green.100"),
  orange: token.var("colors.orange.300"),
  purple: token.var("colors.purple.100"),
  white: token.var("colors.bg.neutral")
};
const BUTTON_TEXT_COLOR = token.var("colors.text.onImpact.neutral-fixed");
const BUTTON_HOVER_CSS = {
  color: "var(--button-text)",
  backgroundColor: "var(--button-hover)",
  borderColor: "var(--button-hover)"
};
const CARD_BASE_CSS = {
  display: "block",
  position: "relative",
  fontFamily: "heading",
  backgroundColor: "var(--background)",
  borderStyle: "solid",
  borderWidth: "1px",
  borderRadius: "obj.soft",
  paddingTop: "default",
  paddingRight: "loose",
  paddingBottom: "loose",
  paddingLeft: "loose",
  "& .Upsell__Button:active:not(:disabled), & .Upsell__Button:focus:not(:disabled), & .Upsell__Button:hover:not(:disabled)": BUTTON_HOVER_CSS
};
const CARD_SIZE_CSS = {
  xs: {
    xl: {
      paddingTop: "layout.looser",
      paddingBottom: "layout.looser",
      paddingRight: "layout.vast.default",
      paddingLeft: "layout.vast.default"
    }
  },
  md: {
    md: {
      padding: "layout.vast.default",
      borderRadius: "obj.soft"
    }
  },
  lg: {
    md: {
      padding: "layout.vast.default",
      borderRadius: "obj.soft"
    }
  }
};
const CARD_BORDER_COLOR = {
  blue: "transparent",
  darkBlue: "transparent",
  gold: "transparent",
  green: "transparent",
  orange: "transparent",
  purple: "transparent",
  white: "border.muted"
};
const UpsellCard = ({
  id,
  button,
  children,
  className,
  color,
  size
}) => (
  // CSS custom properties are set via style (inline, no Panda extraction needed).
  // Structural token CSS is spread from module-level constants (statically extractable).
  /* @__PURE__ */ jsx(Box, { id, "aria-label": button, className, tabIndex: 0, css: {
    ...CARD_BASE_CSS,
    ...size === "xs" && CARD_SIZE_CSS.xs,
    ...size === "md" && CARD_SIZE_CSS.md,
    ...size === "lg" && CARD_SIZE_CSS.lg,
    borderColor: CARD_BORDER_COLOR[color]
  }, style: {
    "--heading": HEADING_COLOR[color],
    "--text": TEXT_COLOR[color],
    "--text-legal": TEXT_LEGAL_COLOR[color],
    "--button": BUTTON_COLOR[color],
    "--button-hover": BUTTON_HOVER_COLOR[color],
    "--button-text": BUTTON_TEXT_COLOR,
    "--background": BACKGROUND_COLOR[color]
  }, children })
);
export {
  UpsellCard as default
};
